export default "__VITE_ASSET__DnfJGmy9__"